var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 3.249a8.403 8.403 0 0 1-2.473.705 4.46 4.46 0 0 0 1.892-2.476 8.452 8.452 0 0 1-2.738 1.088 4.227 4.227 0 0 0-3.143-1.41c-2.376 0-4.306 1.998-4.306 4.467 0 .345.035.687.112 1.012C6.76 6.446 3.586 4.674 1.46 1.973a4.566 4.566 0 0 0-.585 2.245c0 1.551.764 2.909 1.919 3.715a4.183 4.183 0 0 1-1.952-.558v.04c0 2.181 1.484 3.983 3.454 4.391a4.088 4.088 0 0 1-1.134.157 4.32 4.32 0 0 1-.807-.075c.549 1.774 2.138 3.063 4.023 3.097a8.46 8.46 0 0 1-6.379 1.848 11.877 11.877 0 0 0 6.604 2.007c7.923 0 12.256-6.803 12.256-12.703 0-.19-.003-.387-.009-.577A8.974 8.974 0 0 0 21 3.249z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.777bb6a9.svg";
export { ForwardRef as ReactComponent };